
































import FormModal from './FormModal.vue'
import debounce from 'lodash/debounce'
import { cloneDeep } from 'lodash'
import { GatewayServiceProxy, ProductBatchServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'

const gsp = new GatewayServiceProxy()
const pbsp = new ProductBatchServiceProxy()
const registerGateway = gsp.registerGateway.bind(gsp)// 登记网关
const getList = pbsp.getList.bind(pbsp)// 批次列表
export default FormModal.extend({
  name: 'AttributeEditOrAdd',
  props: [],
  data() {
    const fn = this.getBatchList
    return {
      batchList: [], // 批次列表
      filterLoading: false,
      form: {
        name: undefined,
        batchNo: undefined,
        registerCount: undefined
      },
      getBatchListd: debounce(fn, 800)
    }
  },
  computed: {
    rules() {
      return {
        batchNo: [{ required: true, message: this.$t('page_getwat_list_select_batchNo'), trigger: 'blur' }],
        registerCount: [{ required: true, message: this.$t('page_getwat_list_enter_the_registered'), trigger: 'blur' }]
      }
    }
  },
  watch: {
     editData: {
       handler(val) {
         Object.keys(this.form).map(k=>{
           this.form[k] = undefined
         })
         if (JSON.stringify(val) !== '{}') {
           this.form = cloneDeep(val)
         }
       },
       immediate: true,
       deep: true
     },
  },
  methods: {
    initialData() {
      let keys = Object.keys(this.form)
      keys.map(k => this.form[k] = undefined)
      this.getBatchList()
    },
    // 获取批次列表
    async getBatchList(filter) {
      this.filterLoading = true
      try {
        let { items } = await getList(filter ? filter : '')
        this.batchList = items
      } catch (e) {
        this.batchList = []
        console.log(e)
      }
      this.filterLoading = false
    },
    // 登记网关
    async handleSubmit() {
      this.loading = true
      try {
        await registerGateway(this.form)
        this.$message.success(this.$t('page_resource_pool_success'))
        this.loading = false
        this.trigger()
        this.$emit('reload')
      } catch (e) {
        console.log(e)
      }
    }
  }
})
